var render = function render(){
  var _vm$filteredData;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "bg-white"
  }, [_c('div', {
    staticClass: "p-6"
  }, [_c('p', {
    staticClass: "font-bold text-lg mb-6"
  }, [_vm._v("Info")]), _c('div', {
    staticClass: "flex justify-start items-start gap-6"
  }, [_c('div', {
    staticClass: "w-1/5"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("ID")]), _vm.isCostMappingEditMode ? _c('TextField', {
    attrs: {
      "type": "text",
      "disabled": ""
    },
    model: {
      value: _vm.costMappingDetail.id,
      callback: function ($$v) {
        _vm.$set(_vm.costMappingDetail, "id", $$v);
      },
      expression: "costMappingDetail.id"
    }
  }) : _c('p', {
    staticClass: "text-neutral-500 break-all"
  }, [_vm._v(_vm._s(_vm.costMappingDetail.id))])], 1), _c('div', {
    staticClass: "w-4/5"
  }, [_c('label', {
    staticClass: "text-sm text-neutral-700 font-medium mb-1 inline-block"
  }, [_vm._v("Nama Cost Mapping")]), _vm.isCostMappingEditMode ? _c('TextField', {
    attrs: {
      "type": "text"
    },
    model: {
      value: _vm.name,
      callback: function ($$v) {
        _vm.name = $$v;
      },
      expression: "name"
    }
  }) : _c('p', {
    staticClass: "text-neutral-500"
  }, [_vm._v(_vm._s(_vm.costMappingDetail.name))])], 1)])]), _c('div', {
    staticClass: "p-6 shadow-border-b"
  }, [_c('div', {
    staticClass: "flex justify-between items-center gap-6 mb-6"
  }, [_c('p', {
    staticClass: "font-bold text-lg"
  }, [_vm._v("Base Cost")]), _c('span', {
    staticClass: "inline-flex justify-center items-center gap-2 cursor-pointer",
    on: {
      "click": function ($event) {
        return _vm.toggleCostMappingModal();
      }
    }
  }, [_c('CirclePlus', {
    attrs: {
      "color": "primary-500",
      "width": "22",
      "height": "22"
    }
  }), _c('span', {
    staticClass: "text-primary-500 text-base"
  }, [_vm._v("Tambah")])], 1)]), _c('div', {
    staticClass: "list relative"
  }, [((_vm$filteredData = _vm.filteredData) === null || _vm$filteredData === void 0 ? void 0 : _vm$filteredData.length) === 0 ? _c('div', {
    staticClass: "empty text-neutral-400 absolute left-1/2 top-1/2 transform -translate-y-1/2 -translate-x-1/2"
  }, [_vm._v(" Belum terdapat base cost, silakan klik tombol tambah ")]) : [_c('TableComponent', {
    attrs: {
      "columns": _vm.columns,
      "list": _vm.filteredData
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function (_ref) {
        var entry = _ref.entry,
            column = _ref.column,
            index = _ref.index;
        return [column.field === 'action' ? _c('div', {
          staticClass: "flex gap-3"
        }, [_c('span', {
          staticClass: "inline-block cursor-pointer",
          on: {
            "click": function ($event) {
              return _vm.editBaseCost(entry.id);
            }
          }
        }, [_c('Pencil', {
          attrs: {
            "color": "neutral-700"
          }
        })], 1), _c('span', {
          staticClass: "inline-block cursor-pointer",
          on: {
            "click": function ($event) {
              return _vm.toggleDeleteConfirmation(entry.id);
            }
          }
        }, [_c('Trash', {
          attrs: {
            "color": "neutral-700"
          }
        })], 1)]) : column.field === 'id' ? _c('span', {
          staticClass: "block break-all",
          attrs: {
            "title": entry.id
          }
        }, [_vm._v(" " + _vm._s(entry.id) + " ")]) : column.field === 'no' ? _c('span', {
          staticClass: "block"
        }, [_vm._v(" " + _vm._s(index + 1) + " ")]) : _vm.fieldWithCurrencyFormat.indexOf(column.field) > -1 ? _c('span', {
          staticClass: "block"
        }, [_vm._v(" " + _vm._s(_vm._f("currencyFormat")(entry[column.field])) + " ")]) : _c('span', [_vm._v(_vm._s(entry[column.field]))])];
      }
    }])
  }), _vm.filteredData && _vm.filteredData.length > 0 ? _c('div', {
    staticClass: "mt-8 flex justify-center items-center mb-6"
  }, [_c('pagination', {
    attrs: {
      "currentPage": _vm.currentPage,
      "totalCount": _vm.totalRecords,
      "pageSize": _vm.pageSize
    },
    on: {
      "onPageChange": _vm.onPageChange
    }
  })], 1) : _vm._e()]], 2)]), _c('div', {
    staticClass: "flex justify-end gap-6 p-6"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Hapus",
      "type": "delete",
      "icon": function () {
        return import('@/components/Icons/Trash');
      },
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.toggleCMDeleteConfirmation();
      }
    }
  }), _vm.isCostMappingEditMode ? _c('Button', {
    attrs: {
      "buttonText": "Simpan",
      "type": "primary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.save();
      }
    }
  }) : _vm._e()], 1), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleCostMappingModal,
      "width": "600px",
      "id": "cost-mapping-modal"
    },
    on: {
      "close": function ($event) {
        return _vm.toggleCostMappingModal();
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('CostMappingForm', {
    attrs: {
      "isEditMode": _vm.isEditMode,
      "baseCostId": _vm.selectedBaseCostId,
      "costMappingId": _vm.costMappingId,
      "partnerId": _vm.partnerId
    },
    on: {
      "close": function ($event) {
        return _vm.toggleCostMappingModal();
      },
      "refetch": function ($event) {
        return _vm.refetch();
      }
    }
  })], 1)], 2), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleEditConfirmation,
      "width": "600px",
      "id": "edit-confirmation-modal"
    },
    on: {
      "close": function ($event) {
        return _vm.toggleEditConfirmation();
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "flex items-center justify-start gap-6 mb-6"
  }, [_c('span', {
    staticClass: "flex-shrink-0"
  }, [_c('Alert', {
    attrs: {
      "color": "neutral-700"
    }
  })], 1), _c('div', {
    staticClass: "flex-col flex gap-2 items-start"
  }, [_c('p', {
    staticClass: "text-2xl font-bold"
  }, [_vm._v("Peringatan")]), _c('p', {
    staticClass: "text-sm text-neutral-500 text-left"
  }, [_vm._v(" Data perubahan di update dalam mapping cost ini akan berpengahrus pada layanan yang telah tekoneksi dengan mapping cost ini. pastikan base cost dan harga sudah sesuai. ")])])]), _c('div', {
    staticClass: "flex justify-end gap-6"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Batal",
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.toggleEditConfirmation();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Lanjutkan",
      "type": "primary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.confirmEdit();
      }
    }
  })], 1)])], 2), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleDeleteConfirmation,
      "width": "600px",
      "id": "delete-confirmation-modal"
    },
    on: {
      "close": function ($event) {
        return _vm.toggleDeleteConfirmation();
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "flex items-center justify-start gap-6 mb-6"
  }, [_c('span', {
    staticClass: "flex-shrink-0"
  }, [_c('Alert', {
    attrs: {
      "color": "neutral-700"
    }
  })], 1), _c('div', {
    staticClass: "flex-col flex gap-2 items-start"
  }, [_c('p', {
    staticClass: "text-2xl font-bold"
  }, [_vm._v("Hapus Base Cost?")]), _c('p', {
    staticClass: "text-sm text-neutral-500 text-left"
  }, [_vm._v(" Apakah Anda yakin untuk menghapus base cost ini? ")])])]), _c('div', {
    staticClass: "flex justify-end gap-6"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Tidak",
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.toggleDeleteConfirmation();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Ya",
      "type": "primary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.confirmDelete();
      }
    }
  })], 1)])], 2), _c('Modal', {
    attrs: {
      "modalVisible": _vm.visibleCMDeleteConfirmation,
      "width": "600px",
      "id": "delete-confirmation-modal"
    },
    on: {
      "close": function ($event) {
        return _vm.toggleCMDeleteConfirmation();
      }
    }
  }, [_c('template', {
    slot: "modal-content"
  }, [_c('div', {
    staticClass: "flex items-center justify-start gap-6 mb-6"
  }, [_c('span', {
    staticClass: "flex-shrink-0"
  }, [_c('Alert', {
    attrs: {
      "color": "neutral-700"
    }
  })], 1), _c('div', {
    staticClass: "flex-col flex gap-2 items-start"
  }, [_c('p', {
    staticClass: "text-2xl font-bold"
  }, [_vm._v("Hapus Cost Mapping?")]), _c('p', {
    staticClass: "text-sm text-neutral-500 text-left"
  }, [_vm._v(" Menghapus cost mapping akan berpengaruh terhadap layanan dan tidak bisa dibisa di kembalikan. pastikan cost mapping yang akan di buat tidak terkoneksi dengan layanan apapun ")])])]), _c('div', {
    staticClass: "flex justify-end gap-6"
  }, [_c('Button', {
    attrs: {
      "buttonText": "Tidak",
      "type": "secondary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.toggleCMDeleteConfirmation();
      }
    }
  }), _c('Button', {
    attrs: {
      "buttonText": "Ya",
      "type": "primary",
      "size": _vm.isMobile ? 'full' : 'regular'
    },
    on: {
      "action": function ($event) {
        return _vm.confirmCMDelete();
      }
    }
  })], 1)])], 2)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }